OT.createNS('OT.Redesign.DropDown');

OT.Redesign.DropDown = (function($) {
  var menuItemHeight = 40;

  return {
    init: function() {
      var $filterMenus = $('.search-filter-menu'); // $("[id$='-filter-menu']");
      var $filters = $("[id$='-filter-items']");
      var windowHeight = $(window).height();
      var headerHeight = $('#header').height() + 86 + $('#filters-bar-sticky-wrapper').height();
      var heightDifference = windowHeight - headerHeight - 16;

      $filters.each(function() {
        var $filter = $(this);
        var filterItemCount = $filter.children('label').length;
        var filterHeight = filterItemCount * menuItemHeight;
        var filterColCount = Math.min(4, Math.ceil(filterHeight - heightDifference));
        var filterName = $filter.attr('id').split('-')[0];
        var $filterMenu = $('#' + filterName + '-filter-menu');
        var $menuContainer = $filterMenu.find('.menu-container');

        if (filterItemCount <= 5) {
          filterColCount = 1;
        } else if (filterItemCount <= 10) {
          filterColCount = 2;
        } else if (filterItemCount <= 20) {
          filterColCount = 3;
        }

        $menuContainer
          .removeClass('columns1 columns2 columns3 columns4')
          .addClass('columns' + filterColCount);
      });

      $filterMenus.parent().find('.filters[data-target]').each(function() {
        var $filterMenu = $(this);

        if ($filterMenu.attr('data-init')) {
          return;
        }

        $filterMenu.attr('data-init', true);
        $filterMenu.attr('aria-expanded', false);
        $filterMenu.attr('aria-haspopup', true);
        $filterMenu.attr('aria-target', $filterMenu.attr('data-target'));
        $filterMenu.click(function (e) {
          var $target = $("#" + $(e.target).data('target'));
          // when target has a menu-opened class, the target is about to be collapsed and vice versa.
          var expanded = !$target.hasClass('menu-opened');
          $(e.target).attr('aria-expanded', expanded);
        })
        OT.Common.Menus.bindMenu($filterMenu);
        $filterMenu.parent().find('body:not(.device-tablet) .menu-section').lionbars();
      });
    }
  };
})(jQuery);
